import { FuelBottomSheet, FuelDrawer } from '@frete.com/fuel-station-react';
import Profile from 'components/page/Profile';
import { Toasts } from 'components/ui';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { LazyProfileDrawerProps } from 'lazy-profile-drawer/types';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGlobals } from 'hooks/useGlobals';
import { profileOpenigQueryParamsOrigins } from './constants';

export const Content: FC<LazyProfileDrawerProps> = ({ data, isOpen, hideDrawerToasts = false, onClose }) => {
  const { initAmplitude } = useGlobals();

  useEffect(() => {
    if (data?.eventsSource === 'ChatFretebras') {
      initAmplitude?.();
    }
  }, [initAmplitude, data?.eventsSource]);

  const { isMobile } = useDeviceSize();

  const { truckerId: paramsTruckerId, freightId: paramsFreightId } = useParams();
  const [searchParams] = useSearchParams();

  const profileOrigin = searchParams.get('origin');
  const eventsSource = profileOpenigQueryParamsOrigins.includes(profileOrigin) ? profileOrigin : data?.eventsSource;

  const navigate = useNavigate();

  const [isProfileOpen, setIsProfileOpen] = useState(true);
  const [runAsControlledComponent, setRunAsControlledComponent] = useState(true);
  const windowHeight = useRef(window.innerHeight);

  const truckerId = paramsTruckerId || data?.truckerId;
  const freightId = paramsFreightId || data?.freightId;

  const getIsOpen = () => (runAsControlledComponent ? isProfileOpen : isOpen);

  const handleClose = () => {
    onClose?.(navigate);
    if (runAsControlledComponent) {
      setIsProfileOpen(false);
    }
  };

  useEffect(() => {
    if (truckerId) {
      setIsProfileOpen(true);
    }
  }, [runAsControlledComponent]);

  useEffect(() => {
    setRunAsControlledComponent(!!(isOpen === undefined || isOpen === null));
  }, [isOpen]);

  return (
    <>
      {!hideDrawerToasts && <Toasts portalName={data?.portalName} />}
      {isMobile ? (
        <FuelBottomSheet
          isOpen={getIsOpen()}
          portalName={data?.portalName}
          onClose={handleClose}
          height={windowHeight?.current}
          removePortalOnDestroy={false}
          customContainerPadding="0"
          hideHeader
          hideBorderRadius
          customContainerMaxHeight="100vh"
          customBodyMaxHeight="100%"
        >
          <Profile
            data={{
              ...data,
              truckerId,
              freightId,
              hasDrawer: true,
              hideStickyHeader: true,
              dispatchEventOnStart: true,
              hideProfileToasts: true,
              eventsSource,
            }}
            onClose={onClose}
          />
        </FuelBottomSheet>
      ) : (
        <FuelDrawer
          isOpen={getIsOpen()}
          onClose={handleClose}
          portalName={data?.portalName}
          width="lg"
          removePadding
          hideHeader
          removePortalOnDestroy={false}
        >
          <Profile
            data={{
              ...data,
              truckerId,
              freightId,
              hasDrawer: true,
              dispatchEventOnStart: true,
              hideProfileToasts: true,
              eventsSource,
            }}
            onClose={onClose}
          />
        </FuelDrawer>
      )}
    </>
  );
};
